import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-5" }, "My Claims & Reimbursements Summary")
], -1)
const _hoisted_3 = { class: "d-flex justify-content-between align-items-stretch gap-4" }
const _hoisted_4 = { class: "d-flex flex-column align-items-center gap-4 w-25" }
const _hoisted_5 = { class: "card w-100" }
const _hoisted_6 = { class: "card-body d-flex flex-column align-items-center gap-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, " Current MRP Balance: ", -1)
const _hoisted_8 = { class: "btn btn-warning" }
const _hoisted_9 = { class: "d-flex flex-column align-items-center justify-content-between h-100" }
const _hoisted_10 = { class: "card d-flex align-items-center gap-4 w-100" }
const _hoisted_11 = { class: "card-body d-flex flex-column align-items-center gap-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "New Claim", -1)
const _hoisted_13 = { class: "card d-flex align-items-center gap-4 w-100" }
const _hoisted_14 = { class: "card-body d-flex flex-column align-items-center gap-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", null, "Existing Claims", -1)
const _hoisted_16 = { class: "d-flex flex-column align-items-center gap-2 w-75" }
const _hoisted_17 = { class: "card d-flex align-items-center gap-4 w-100" }
const _hoisted_18 = { class: "card-body d-flex justify-content-between gap-4 w-75" }
const _hoisted_19 = { class: "d-flex justify-content-between align-items-center gap-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, " What is Covered/ Reimbursable ? ", -1)
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "d-flex align-items-center gap-4" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "card d-flex align-items-center gap-4 w-100" }
const _hoisted_25 = { class: "card-body d-flex align-items-center gap-4" }
const _hoisted_26 = { class: "d-flex flex-column align-items-center gap-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", null, " Claims History ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, "Your most recent claims history is displayed below. To view a specific claim listed, click on the claim number. For those received via this website, but not yet reviewed, you can click on the Web Reference number to view /edit your uploaded documents or add additional documents. To search for a specific date range or for claims not listed below please click the Search button and choose your search criteria. ", -1)
const _hoisted_29 = {
  id: "collapse",
  class: "w-100"
}
const _hoisted_30 = { class: "table table-bordered table-striped" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("thead", { class: "table-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Date Filed"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Web Ref #"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim Doc(s)")
  ])
], -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { colspan: "5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, " $ " + _toDisplayString($setup.loading ? "Loading..." : $setup.data?.MrpBalance), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_router_link, {
                to: { name: 'participant.claims.new' },
                class: "btn btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Submit a New Claim ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_router_link, {
                to: { name: 'participant.claims.search' },
                class: "btn btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Go to Existing Claims")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: { name: 'participant.claims.update.address' },
              class: "btn btn-secondary"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Change Mailing Address / Claims Payment Setup")
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("a", {
                href: $setup.data?.CoveredList,
                target: "_blank",
                class: "btn btn-secondary"
              }, " See List ", 8, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("a", {
                href: $setup.data?.ClaimForm,
                target: "_blank",
                class: "btn btn-warning"
              }, " Download Claim Form ", 8, _hoisted_23)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("table", _hoisted_30, [
                  _hoisted_31,
                  ($setup.data?.Claims?.length > 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data?.Claims, (claim) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: claim.ClaimID,
                            class: "text-center"
                          }, [
                            _createElementVNode("td", null, _toDisplayString(claim.DateReceived), 1),
                            (claim?.ClaimID)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'participant.claims.new', params: { ClaimID: claim?.ClaimID, Type: claim?.Type } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(claim?.ClaimID), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(claim.ClaimID == '0' ? '' : claim.ClaimID), 1)),
                            (!claim?.ClaimID)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'participant.claims.new', params: { ClaimID: claim?.NEICID, Type: claim?.Type } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(claim?.NEICID), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString(claim?.NEICID), 1)),
                            _createElementVNode("td", null, _toDisplayString(claim.ClaimStatus), 1),
                            _createElementVNode("td", null, _toDisplayString(claim.DocumentID), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_37, [
                        _createElementVNode("tr", _hoisted_38, [
                          _createElementVNode("td", _hoisted_39, _toDisplayString($setup.loading ? "Loading..." : "No Data Available"), 1)
                        ])
                      ]))
                ])
              ]),
              _createVNode(_component_router_link, {
                to: { name: 'participant.claims.search' },
                class: "btn btn-secondary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Search Claims History ")
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ])
      ])
    ])
  ]))
}